import { BackendErrorPayload } from '@paywithextend/components/dist/error.utils'
import axios from 'axios'
import queryString from 'query-string'
import { ThunkAction, ThunkDispatch } from 'redux-thunk'
import { GetUserConnectionsQueryParams } from 'src/app/PeopleContacts/redux/peopleContacts.actions'
import { PeopleMembersResponse } from 'src/models/people.models'
import { RootState } from 'src/redux/createRootReducer'
import { selectAuthedJsonApiRequestConfig } from 'src/redux/selectors/axios.selectors'

export const GET_ORGANIZATION_MEMBERS_INIT =
  'app/people/peopleMembers/GET_ORGANIZATION_MEMBERS_INIT'
export const GET_ORGANIZATION_MEMBERS_SUCCESS =
  'app/people/peopleMembers/GET_ORGANIZATION_MEMBERS_SUCCESS'
export const GET_ORGANIZATION_MEMBERS_FAILURE =
  'app/people/peopleMembers/GET_ORGANIZATION_MEMBERS_FAILURE'

export type GetOrganizationMembersSuccessPayload = PeopleMembersResponse

export type GetOrganizationMembersFailurePayload = BackendErrorPayload<string>

export interface GetOrganizationMembersInitAction {
  type: typeof GET_ORGANIZATION_MEMBERS_INIT
}
export interface GetOrganizationMembersSuccessAction {
  type: typeof GET_ORGANIZATION_MEMBERS_SUCCESS
  payload: GetOrganizationMembersSuccessPayload
}
export interface GetOrganizationMembersFailureAction {
  type: typeof GET_ORGANIZATION_MEMBERS_FAILURE
  payload: GetOrganizationMembersFailurePayload
}

export type GetPeopleMembersActions =
  | GetOrganizationMembersInitAction
  | GetOrganizationMembersSuccessAction
  | GetOrganizationMembersFailureAction

export const createGetOrganizationMembersInitAction =
  (): GetOrganizationMembersInitAction => ({
    type: GET_ORGANIZATION_MEMBERS_INIT,
  })
const createGetOrganizationMembersSuccessAction = (
  payload: GetOrganizationMembersSuccessPayload,
): GetOrganizationMembersSuccessAction => ({
  type: GET_ORGANIZATION_MEMBERS_SUCCESS,
  payload,
})
const createGetOrganizationMembersFailureAction = (
  payload: GetOrganizationMembersFailurePayload,
): GetOrganizationMembersFailureAction => ({
  type: GET_ORGANIZATION_MEMBERS_FAILURE,
  payload,
})

export const getOrgMembers = (
  organizationId: string,
  queryParameters?: GetUserConnectionsQueryParams,
): ThunkAction<
  Promise<
    GetOrganizationMembersFailureAction | GetOrganizationMembersSuccessAction
  >,
  RootState,
  void,
  GetPeopleMembersActions
> => {
  return async (
    dispatch: ThunkDispatch<RootState, void, GetPeopleMembersActions>,
    getState: () => RootState,
  ): Promise<
    GetOrganizationMembersFailureAction | GetOrganizationMembersSuccessAction
  > => {
    dispatch(createGetOrganizationMembersInitAction())
    return axios
      .get<GetOrganizationMembersSuccessPayload>(
        `/organizations/${organizationId}/members?${queryParameters ? queryString.stringify(queryParameters) : ''}`,
        selectAuthedJsonApiRequestConfig(getState()),
      )
      .then(
        async (response) => {
          return dispatch(
            createGetOrganizationMembersSuccessAction(response.data),
          )
        },
        (err) => {
          return dispatch(
            createGetOrganizationMembersFailureAction(err.response.data),
          )
        },
      )
  }
}
